import React from 'react'
import Helmet from 'react-helmet';

import Base from './base';
import { Parent } from '../layouts/parent';

import { Newsletter } from '../components/newsletter';
import { ContentIntro } from '../components/content-intro';
import { ContentHead } from '../components/content-head';
import { ContentHeadCompact } from '../components/content-head-compact';
import { NewsList } from '../components/news-list';
import { ContentColumns } from '../components/content-columns';
import { TeamSection } from '../components/team-section';
import { FestivalTwoColumns } from '../components/festival-two-colums';
import { EmbeddedVideo } from '../components/embedded-video';
import { Gallery } from '../components/content-gallery';
import { PartnerGroup } from '../components/partners';
import { ArchiveOverview } from '../components/archive-overview';
import { EventGrid } from '../components/event-grid';
import { Form } from '../components/form';
import { Search } from '../components/search';
import { Parcours } from '../components/parcours';
import { ModuleIframe } from '../components/iframe';
import { EventCalendar } from '../components/calendar';

export default class ContentPage extends Base {
  get backgroundColor () {
    return this.content.page?.festival?.color || '#5F58FA';
  }

  get breadcrumb () {
    return this.content.page.festival.title;
  }

  get injected () {
    return this.content.injected || {};
  }

  get hasPageHeader () {
    if (!this.content.page.modules) return false;
    return this.content.page.modules.some(module => module.type == 'modulePageHeader');
  }

  render () {
    return (
      <Parent { ...this.content }>
        <Helmet>
          <title>{`${ this.content.page.shortTitle || this.content.page.title } | ${ this.breadcrumb } | Europalia Arts Festival`}</title>
          <meta name="description" content={this.content.page.excerpt} />
          { this.image && <meta property="og:image" content={'https:' + this.image } /> }
        </Helmet>

        { !this.hasPageHeader && <ContentHeadCompact breadcrumb={this.breadcrumb}>{ this.content.page.shortTitle }</ContentHeadCompact> }

        { this.content.page.modules && this.content.page.modules.map(module => {
          if (module.type === 'modulePageHeader')     return <ContentHead {...module} backgroundColor={this.backgroundColor} />;
          if (module.type === 'moduleIntro')          return <ContentIntro {...module} />;
          if (module.type === 'moduleLatestNews')     return <NewsList {...module} {...this.injected[module.id]}/>;
          if (module.type === 'moduleNewsletter')     return <Newsletter {...module} />;
          if (module.type === 'moduleSearch')         return <Search {...module} />;
          if (module.type === 'moduleParcours')       return <Parcours {...module} />;
          if (module.type === 'moduleIframe')         return <ModuleIframe {...module} />;
          if (module.type === 'moduleTeamMembers')    return <TeamSection {...module} />;
          if (module.type === 'moduleTextIn2Columns') return <ContentColumns {...module} />;
          if (module.type === 'moduleEmbeddedVideo')  return <EmbeddedVideo {...module} />;
          if (module.type === 'moduleImageGallery')   return <Gallery {...module} />;
          if (module.type === 'moduleEventGrid')      return <EventGrid {...module} {...this.injected[module.id]} festival={this.content.page?.festival} />;
          if (module.type === 'moduleEventCalendar')  return <EventCalendar {...module} {...this.injected[module.id]} festival={this.content.page?.festival} />;
          if (module.type === 'patnerGroup')          return <PartnerGroup {...module} />;
          if (module.type === 'form')                 return <Form {...module} key={module.id} />;
          if (module.type === 'moduleArchiveOverview') return <ArchiveOverview {...module} {...this.injected[module.id]} />;
          if (module.type === 'moduleFestivalBlocksTwoColumns') return <FestivalTwoColumns {...module} />;
        
          return <React.Fragment />;
        })}
      </Parent>
    );
  }
}